<template>
  <v-app
    light
    class="no-border"
  >
    <!-- top toolbar START -->
    <v-toolbar>
      <v-toolbar-title>
        <img
          src="@/assets/img/Logotype_Light.png"
          height="38px"
        ></img>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items class="">
        <v-btn
          text
          to="/signin"
        >
          Sign in
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- top toolbar END -->

    <v-container
      class="fill-height"
    >
      <v-row
        justify="center"
      >
        <v-col cols="12" />
        <v-col
          cols="12"
          sm="8"
          md="8"
          lg="6"
          class="text-center"
        >
          <h1 class="display-3">
            Having trouble to connect?
          </h1>
          <h3 class="mb-5">
            No worries, we'll help you.
          </h3>

          <!-- support buttons v-for START -->
          <template v-for="item in dialogItems">
            <v-col
              cols="12"
              class="text-center"
            >
              <v-btn
                large
                class="primary mb-3"
                @click.native="openDialog(item.type)"
              >
                {{ item.buttonText }}
              </v-btn>
            </v-col>
          </template>
          <!-- support buttons v-for END -->

          <!-- dialog START -->
          <v-dialog
            v-model="dialog"
            max-width="400px"
          >
            <v-card>
              <v-card-title class="headline">
                {{ selectedItem.title }}
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-if="selectedItem.email===true"
                  v-model="userInput"
                  v-validate="'required|email'"
                  label="e-mail"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  required
                />
              </v-card-text>
              <v-card-text>{{ selectedItem.text }}</v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color=""
                  text
                  @click.native="dialog=false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  @click.native="actionMethod(selectedItem.type)"
                >
                  {{ selectedItem.actionText }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- dialog END -->
        </v-col>
        <v-col cols="12" />
      </v-row>
    </v-container>
    <content-footer />
    <notify />
  </v-app>
</template>

<script>
  import AccountService from './services/AccountService.js'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    data: function () {
      return {
        dialog: false,
        dialogItems: [
          { type: 'lostPassword', buttonText: 'lost password', email: true, title: 'Reset Your Password', text: 'To reset your password, enter the email address you use, and we\'ll send you further instructions by email.', actionText: 'send' },
          { type: 'emailNotReceived', buttonText: 'e-mail not received', email: true, title: 'Confirmation email', text: 'Enter your email address, click send and follow the email instructions.', actionText: 'send' },
        ],
        selectedItem: Number,
        userInput: '',

      }
    },
    mounted: function () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      openDialog: function (type) {
        var index = this.dialogItems.findIndex(x => x.type === type)
        this.selectedItem = this.dialogItems[index]
        this.dialog = true
      },
      actionMethod: function (type) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            switch (type) {
              case 'lostPassword':
                AccountService.resetPassword(this.userInput, this)
                break
              case 'emailNotReceived':
                AccountService.emailNotReceived(this.userInput, this)
                break
              default:
                break
            }
            this.dialog = false
          }
        })
      },
    },
  }
</script>
